// Which product lines this dashboard serves (teisyovision plan.md phase 13).
//
// One build serves every admin host. Before a branch's gym database is merged
// into its clinic's, each of its two hosts faces one API and one line; after,
// one host faces the merged API and both. The site server says which per host
// (internal/admin, `productLines`); absent -- the dev server, the mocked e2e
// suite -- is both, the fullest form of the app.
import { runtimeConfig } from "@booking/core-ui/runtime-config";

const lines = new Set(
  (runtimeConfig.productLines ?? "clinic,gym")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean),
);

export const hasClinic = lines.has("clinic");
export const hasGym = lines.has("gym");
/** One company running both: the grouped nav, service kinds, the special's scope. */
export const bothLines = hasClinic && hasGym;
